(function () {
  function boot(root) {
    if (!root || root.dataset.smgBooted) return;
    root.dataset.smgBooted = '1';

    var grid = root.querySelector('[data-smg-grid]');
    var actions = root.querySelector('[data-smg-actions]');
    var loadMoreBtn = root.querySelector('[data-smg-load-more]');
    var statusEl = root.querySelector('[data-smg-status]');
    var productLabel = root.dataset.productLabel || 'Weight Loss Reset';
    var productImage = root.dataset.productImage || '';

    // Okendo export still uses Level 1/2/3 names — map to current program brands.
    var PRODUCT_MAP = {
      'TRANSFORM Level 1': {
        name: 'Weight Loss Reset',
        image:
          'https://cdn.shopify.com/s/files/1/2320/2099/files/Fitazfk21477_1.png?v=1778129273',
      },
      'Weight Loss Reset': {
        name: 'Weight Loss Reset',
        image:
          'https://cdn.shopify.com/s/files/1/2320/2099/files/Fitazfk21477_1.png?v=1778129273',
      },
      'TRANSFORM Level 2': {
        name: 'Strength and Tone',
        image:
          'https://cdn.shopify.com/s/files/1/2320/2099/files/Strength_and_tone.png?v=1778576768',
      },
      'Strength and Tone': {
        name: 'Strength and Tone',
        image:
          'https://cdn.shopify.com/s/files/1/2320/2099/files/Strength_and_tone.png?v=1778576768',
      },
      'TRANSFORM Level 3': {
        name: 'Shape and Sculpt',
        image:
          'https://cdn.shopify.com/s/files/1/2320/2099/files/Shape_Sculpt.png?v=1778576768',
      },
      'Shape and Sculpt': {
        name: 'Shape and Sculpt',
        image:
          'https://cdn.shopify.com/s/files/1/2320/2099/files/Shape_Sculpt.png?v=1778576768',
      },
    };

    function resolveProduct(group) {
      var raw = (group && group.productName) || productLabel || '';
      var mapped = PRODUCT_MAP[raw];
      if (mapped) {
        return { name: mapped.name, image: mapped.image };
      }
      return { name: raw || productLabel, image: productImage };
    }

    // Okendo's default media grid: 5 columns / 3 columns, with a 2x2 tile
    // every second row-block. Page sizes below mirror the live widget.
    var LAYOUT = {
      desktop: { initial: 14, batch: 7, largeEvery: 10 },
      mobile: { initial: 9, batch: 3, largeEvery: 9 },
    };

    function isDesktop() {
      return window.matchMedia('(min-width: 1024px)').matches;
    }

    function layout() {
      return isDesktop() ? LAYOUT.desktop : LAYOUT.mobile;
    }

    var items = [];
    var groupsByParent = {};
    var shown = 0;
    var lastFocus = null;
    var modalHost = null;
    var modalEl = null;
    var activeGroup = null;
    var activeMediaIndex = 0;

    function escapeHtml(str) {
      return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function thumbSrc(item) {
      if (item.type === 'video') return item.shopify_poster_cdn_url || item.shopify_cdn_url;
      return item.shopify_cdn_url;
    }

    function setStatus(msg, hide) {
      if (!statusEl) return;
      if (hide) {
        statusEl.hidden = true;
        statusEl.textContent = '';
        return;
      }
      statusEl.hidden = false;
      statusEl.textContent = msg || '';
    }

    function syncGridClass() {
      if (!grid) return;
      var desktop = isDesktop();
      grid.classList.toggle('oke-mediaGrid-container--default-desktop', desktop);
      grid.classList.toggle('oke-mediaGrid-container--default-mobile', !desktop);

      var wrapper = grid.closest('.okeReviews.oke-mediaGrid');
      if (wrapper) {
        wrapper.classList.toggle('oke-is-large', desktop);
        wrapper.classList.toggle('oke-is-small', !desktop);
      }
    }

    function buildGroups(list) {
      groupsByParent = {};
      list.forEach(function (item) {
        var pid = item.parentId || item.id;
        item._parentId = pid;
        if (!groupsByParent[pid]) {
          groupsByParent[pid] = {
            parentId: pid,
            reviewer: item.reviewer,
            title: item.title,
            body: item.body,
            rating: item.rating,
            isVerified: item.isVerified,
            productName: item.productName || productLabel,
            media: [],
          };
        }
        item._mediaIndex = groupsByParent[pid].media.length;
        groupsByParent[pid].media.push(item);
      });
    }

    function groupFor(item) {
      return groupsByParent[item._parentId];
    }

    function starsLabel(rating) {
      var n = Math.max(0, Math.min(5, parseInt(rating, 10) || 0));
      return 'Rated ' + n + ' out of 5 stars';
    }

    // Okendo renders stars at height 12 in the grid overlay and 22 in the modal,
    // each with its own viewBox width / <use> offset.
    var STAR_SIZES = {
      small: { height: 12, viewBox: '0 0 82.33333333333331 14', step: 16.933333333333334 },
      large: { height: 22, viewBox: '0 0 90.81818181818183 14', step: 19.054545454545455 },
    };

    function starsHtml(rating, size) {
      var n = Math.max(0, Math.min(5, parseInt(rating, 10) || 0));
      var pct = (n / 5) * 100;
      var s = STAR_SIZES[size] || STAR_SIZES.small;
      var layer = function (cls, id, style) {
        return (
          '<div class="' + cls + '"' + (style || '') + '>' +
          '<svg height="' + s.height + '" viewBox="' + s.viewBox + '" aria-hidden="true" role="none">' +
          [0, 1, 2, 3, 4]
            .map(function (i) {
              return '<use x="' + i * s.step + '" href="#' + id + '"></use>';
            })
            .join('') +
          '</svg></div>'
        );
      };

      return (
        '<div class="oke-stars">' +
        layer('oke-stars-background', 'oke-star-empty') +
        layer('oke-stars-foreground', 'oke-star-filled', ' style="width:' + pct + '%;"') +
        '<span class="oke-a11yText">' +
        escapeHtml(starsLabel(n)) +
        '</span></div>'
      );
    }

    function productHtml(group) {
      var resolved = resolveProduct(group);
      var name = resolved.name;
      var image = resolved.image;
      return (
        '<div class="oke-w-reviewSimple-product"><div class="oke-product">' +
        (image
          ? '<div aria-hidden="true" tabindex="-1" class="oke-product-thumbnail">' +
            '<img alt="' +
            escapeHtml(name) +
            '" class="oke-product-thumbnail-image" src="' +
            escapeHtml(image) +
            '"></div>'
          : '') +
        '<div class="oke-product-details">' +
        '<div class="oke-product-details-title"> Reviewing </div>' +
        '<span class="oke-product-details-name"> ' +
        escapeHtml(name) +
        ' </span>' +
        '</div></div></div>'
      );
    }

    function ensureModalHost() {
      if (modalHost) return modalHost;
      modalHost = document.getElementById('oke-modalContainer');
      if (!modalHost) {
        modalHost = document.createElement('div');
        modalHost.id = 'oke-modalContainer';
        document.body.appendChild(modalHost);
      }
      return modalHost;
    }

    function closeModal() {
      if (!modalEl) return;
      var vid = modalEl.querySelector('video');
      if (vid) {
        try {
          vid.pause();
        } catch (e) {}
      }
      modalHost.innerHTML = '';
      modalEl = null;
      activeGroup = null;
      document.body.classList.remove('is-oke-modalOpen');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function updateNavButtons() {
      if (!modalEl || !activeGroup) return;
      var prev = modalEl.querySelector('[data-smg-nav-prev]');
      var next = modalEl.querySelector('[data-smg-nav-next]');
      if (!prev || !next) return;
      var multi = activeGroup.media.length > 1;
      prev.disabled = !multi || activeMediaIndex <= 0;
      next.disabled = !multi || activeMediaIndex >= activeGroup.media.length - 1;
      prev.hidden = !multi;
      next.hidden = !multi;
    }

    function renderMainMedia(item) {
      var main = modalEl.querySelector('[data-smg-modal-main]');
      if (!main) return;
      main.innerHTML = '';
      if (item.type === 'video') {
        var video = document.createElement('video');
        video.className = 'oke-video oke-mediaGallery-slider-image';
        video.src = item.shopify_cdn_url;
        video.controls = true;
        video.playsInline = true;
        video.preload = 'metadata';
        video.poster = item.shopify_poster_cdn_url || '';
        main.appendChild(video);
        try {
          video.play();
        } catch (e) {}
      } else {
        var img = document.createElement('img');
        img.className = 'oke-media-image oke-mediaGallery-slider-image';
        img.src = item.shopify_cdn_url;
        img.alt = item.imageAlt || item.title || '';
        main.appendChild(img);
      }
    }

    function renderThumbs(group) {
      var track = modalEl.querySelector('[data-smg-modal-thumbs]');
      var nav = modalEl.querySelector('[data-smg-modal-nav]');
      if (!nav || !track) return;
      track.innerHTML = '';
      if (group.media.length <= 1) {
        nav.hidden = true;
        updateNavButtons();
        return;
      }
      nav.hidden = false;
      group.media.forEach(function (media, idx) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'oke-mediaGallery-nav-button';
        if (idx === activeMediaIndex) btn.classList.add('is-oke-selected');
        btn.setAttribute('aria-label', 'Media ' + (idx + 1));
        btn.setAttribute('aria-selected', idx === activeMediaIndex ? 'true' : 'false');
        btn.innerHTML =
          '<img class="oke-mediaGallery-nav-button-image" src="' +
          escapeHtml(thumbSrc(media)) +
          '" alt="" loading="lazy" decoding="async">';
        btn.addEventListener('click', function () {
          setActiveMedia(group, idx);
        });
        track.appendChild(btn);
      });
      updateNavButtons();

      var selected = track.querySelector('.is-oke-selected');
      if (selected && selected.scrollIntoView) {
        selected.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    function setActiveMedia(group, index) {
      activeGroup = group;
      activeMediaIndex = index;
      renderMainMedia(group.media[index]);
      renderThumbs(group);
    }

    function openModal(group, mediaIndex) {
      lastFocus = document.activeElement;
      activeGroup = group;
      activeMediaIndex = mediaIndex || 0;
      ensureModalHost();

      modalHost.innerHTML =
        '<div class="okeReviews">' +
          '<div class="oke-modal oke-modal-overlay">' +
            '<div class="oke-modal-content" role="dialog" aria-modal="true" data-smg-dialog>' +
              '<button type="button" class="oke-modal-close" data-smg-close title="Close Dialog" aria-label="Close Dialog"></button>' +
              '<div class="oke-mediaGallery">' +
                '<div class="oke-mediaGallery-review">' +
                  '<div class="oke-w-reviewSimple">' +
                    '<div class="oke-w-reviewSimple-reviewer">' +
                      '<div class="oke-w-reviewer"><div>' +
                        '<div class="oke-w-reviewer-identity">' +
                          '<strong class="oke-w-reviewer-name"> ' +
                          escapeHtml(group.reviewer || '') +
                          ' </strong>' +
                        '</div>' +
                        (group.isVerified
                          ? '<div class="oke-w-reviewer-verified"> Verified Buyer' +
                            '<span class="oke-w-reviewer-verified-icon"></span></div>'
                          : '') +
                      '</div></div>' +
                    '</div>' +
                    productHtml(group) +
                    '<div class="oke-w-reviewSimple-content">' +
                      '<div class="oke-reviewContainer">' +
                        '<div class="oke-reviewContent oke-reviewContent--left">' +
                          '<div class="oke-reviewContent-top">' +
                            '<div class="oke-reviewContent-stars" aria-label="' +
                            escapeHtml(starsLabel(group.rating)) +
                            '">' +
                            starsHtml(group.rating, 'large') +
                            '</div>' +
                          '</div>' +
                          (group.title
                            ? '<div class="oke-reviewContent-title oke-title" role="heading" aria-level="2">' +
                              escapeHtml(group.title) +
                              '</div>'
                            : '') +
                          '<div class="oke-reviewContent-body oke-bodyText"><p>' +
                          escapeHtml(group.body || '') +
                          '</p></div>' +
                        '</div>' +
                      '</div>' +
                    '</div>' +
                  '</div>' +
                '</div>' +
                '<div class="smg-media-col">' +
                  '<div class="oke-mediaGallery-slider" data-smg-modal-main></div>' +
                  '<div class="oke-mediaGallery-nav" data-smg-modal-nav hidden>' +
                    '<button type="button" class="oke-mediaGallery-nav-prev" data-smg-nav-prev title="Previous Slide" aria-label="Previous Slide"></button>' +
                    '<div class="oke-mediaGallery-nav-track" data-smg-modal-thumbs></div>' +
                    '<button type="button" class="oke-mediaGallery-nav-next" data-smg-nav-next title="Next Slide" aria-label="Next Slide"></button>' +
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>';

      modalEl = modalHost.querySelector('.oke-modal');
      setActiveMedia(group, activeMediaIndex);
      document.body.classList.add('is-oke-modalOpen');

      modalEl.querySelector('[data-smg-close]').addEventListener('click', closeModal);
      modalEl.addEventListener('click', function (e) {
        if (e.target === modalEl) closeModal();
      });

      var prevBtn = modalEl.querySelector('[data-smg-nav-prev]');
      var nextBtn = modalEl.querySelector('[data-smg-nav-next]');
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          if (!activeGroup || activeMediaIndex <= 0) return;
          setActiveMedia(activeGroup, activeMediaIndex - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          if (!activeGroup || activeMediaIndex >= activeGroup.media.length - 1) return;
          setActiveMedia(activeGroup, activeMediaIndex + 1);
        });
      }

      modalEl.querySelector('[data-smg-close]').focus();
    }

    function mediaHtml(item, eager) {
      var src = thumbSrc(item);
      var alt = escapeHtml(item.imageAlt || item.title || item.reviewer || '');
      var loading = eager ? 'eager' : 'lazy';
      var videoClass = item.type === 'video' ? ' oke-media--video' : '';

      return (
        '<div class="oke-media oke-mediaGrid-thumbnail oke-media--linked' +
        videoClass +
        '">' +
        '<button type="button" class="oke-media-link" tabindex="-1" aria-label="' +
        alt +
        '">' +
        '<img class="oke-media-image" src="' +
        escapeHtml(src) +
        '" alt="' +
        alt +
        '" loading="' +
        loading +
        '" decoding="async" draggable="false">' +
        '</button></div>'
      );
    }

    function overlayHtml(group) {
      return (
        '<div class="oke-mediaOverlay oke-mediaGrid-overlay">' +
        '<div class="oke-mediaOverlay-rating">' +
        starsHtml(group.rating) +
        '</div>' +
        '<div class="oke-mediaOverlay-text">' +
        escapeHtml(group.body || '') +
        '</div>' +
        '<button type="button" class="oke-mediaOverlay-button" tabindex="-1"> Read More </button>' +
        '<div aria-hidden="true" class="oke-mediaOverlay-clickableMask"></div>' +
        '</div>'
      );
    }

    function tileFor(item, globalIndex) {
      var group = groupFor(item);
      var tile = document.createElement('div');
      tile.className = 'oke-mediaGrid-item';
      tile.setAttribute('role', 'listitem');
      if (globalIndex % layout().largeEvery === 0) tile.classList.add('is-smg-large');

      tile.innerHTML = mediaHtml(item, globalIndex < 3) + overlayHtml(group);

      function openFromTile(e) {
        if (e) e.stopPropagation();
        openModal(group, item._mediaIndex);
      }

      tile.querySelector('.oke-media-link').addEventListener('click', openFromTile);
      tile.querySelector('.oke-mediaOverlay-clickableMask').addEventListener('click', openFromTile);
      tile.querySelector('.oke-mediaOverlay-button').addEventListener('click', openFromTile);

      return tile;
    }

    function renderUpTo(count) {
      var end = Math.min(count, items.length);
      var frag = document.createDocumentFragment();
      for (var i = 0; i < end; i++) {
        frag.appendChild(tileFor(items[i], i));
      }
      grid.innerHTML = '';
      grid.appendChild(frag);
      shown = end;
      if (actions) actions.hidden = shown >= items.length;
      grid.setAttribute('aria-busy', 'false');
    }

    // Column count and page size both change at the breakpoint, so re-render
    // rather than leaving 2x2 tiles at indexes that no longer line up.
    function relayout() {
      syncGridClass();
      if (!items.length) return;
      renderUpTo(Math.max(shown, layout().initial));
    }

    document.addEventListener('keydown', function (e) {
      if (!modalEl || !activeGroup) return;
      if (e.key === 'Escape') {
        closeModal();
        return;
      }
      if (activeGroup.media.length <= 1) return;
      if (e.key === 'ArrowRight') {
        setActiveMedia(activeGroup, Math.min(activeMediaIndex + 1, activeGroup.media.length - 1));
      }
      if (e.key === 'ArrowLeft') {
        setActiveMedia(activeGroup, Math.max(activeMediaIndex - 1, 0));
      }
    });

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        renderUpTo(shown + layout().batch);
      });
    }

    syncGridClass();
    window.matchMedia('(min-width: 1024px)').addEventListener('change', relayout);

    fetch(root.dataset.src, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to load media grid data');
        return res.json();
      })
      .then(function (data) {
        items = Array.isArray(data) ? data.filter(function (d) { return d && d.shopify_cdn_url; }) : [];
        if (!items.length) {
          setStatus('No reviews to show.');
          return;
        }
        buildGroups(items);
        setStatus('', true);
        renderUpTo(layout().initial);
      })
      .catch(function () {
        setStatus('Unable to load reviews.');
        grid.setAttribute('aria-busy', 'false');
      });
  }

  document.querySelectorAll('[data-static-media-grid]').forEach(boot);
})();

/* smg-build 20260907235014 */

/* smg-dom 20260908001151 */
